export async function simpleFetch(url: string) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      console.error(response.status);
    }
    const json = await response.json();
    return json;
  } catch (error) {
    console.error(error);
  }
}
